import React, { memo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import BaseTopBar from "@ls/react-top-bar";
import KebabMenu from "components/KebabMenu";
import MainTitle from "components/MainTitle";
import InfoSection from "components/InfoSection";
import { selectAppNameTitle } from "state/app/selectors";

const TopBar = (props) => {
  const appNameTitle = useSelector(selectAppNameTitle);

  return (
    <BaseTopBar
      onMenuButtonClick={props.toggleDrawer}
      menuButtonActive={props.drawerOpen}
      mainTitleComponent={<MainTitle />}
      infoSection={<InfoSection />}
      rightSideComponent={<KebabMenu />}
      appName={!!appNameTitle ? appNameTitle : "Portfolio Analytics"}
    />
  );
};

TopBar.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
};

export default memo(TopBar);
